





































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListItakusaki from '@/components/common/search/ListItakusaki.vue';
import { API_SEARCH_ITAKUSAKI } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';


export default Vue.extend<any, any, any, any>({
  name: 'CtrlItakusaki',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListItakusaki,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '配送会社',
    },
    widthCd: {
      type: Number,
      default: 84,
    },
    widthName: {
      type: Number,
      default: 340,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    haisoKaishaCd: {
      type: Number,
      required: true,
    },
    itakusakiCd: {
      type: Number,
      required: true,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_ITAKUSAKI,
    ListItakusakiShow: false,
    mounted: false,
    itakusakiCd: 0,
    itakusakiRyakuMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { itakusakiCd, itakusakiRyakuMei } = item;
      console.log(itakusakiCd);
      this.itakusakiCd = itakusakiCd;
      this.itakusakiRyakuMei = itakusakiRyakuMei;
      this.ListItakusakiShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.ListItakusakiShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    async handleChange(value: number) {
      if (!this.mounted) return;
      this.itakusakiCd = value;
      if (value) {
        await this.getItakusakiItem();
      } else {
        this.itakusakiRyakuMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ itakusakiCd: this.itakusakiCd });
      }
    },
    async getItakusakiItem() {
      const res = await axios.get(API_SEARCH_ITAKUSAKI, {
        params: {
          haisoKaishaCd: this.haisoKaishaCd,
          itakusakiCd: this.itakusakiCd,
          mukoUmuFlg: this.mukoUmuFlg,
        },
      });
      if (!res.data.responseData || res.data.responseData.length === 0) {
        this.itakusakiRyakuMei = '';
        this.isNoData = true;
        this.errors = noDataError();

        this.callbackOk && this.callbackOk({ itakusakiCd: this.itakusakiCd });
        return;
      }
      this.errors = clearNoDataError();
      const { itakusakiRyakuMei } = res.data.responseData[0];
      this.itakusakiRyakuMei = itakusakiRyakuMei;
      this.callbackOk && this.callbackOk(res.data.responseData[0]);
      this.isNoData = false;
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [itakusakiCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.itakusakiCd': {
      async handler(newValue) {
        if (newValue === undefined || +newValue === +this.itakusakiCd) return;
        this.itakusakiCd = +newValue;
        if (newValue) {
          await this.getItakusakiItem();
        } else {
          this.itakusakiRyakuMei = '';
          this.errors = clearNoDataError();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.mounted = true;
  },
});
